const damageLocationsSelected = {
    WINDSHIELD: "Windshield",
    SIDEDOOR: "SideDoor",
    REARWINDOW: "RearWindow",
    REPAIR: "Repair",
    REPLACE: "Replace",
    DRIVER: "Driver",
    PASSENGER: "Passenger",
    FRONT: "Front",
    REAR: "Rear",
    BACK: "Back",
    QUARTER: "Quarter",
    VENT: "Vent",
    SINGLE: "Single",
    DRIVERSIDE: "DriverSide",
    PASSENGERSIDE: "PassengerSide",
    STATIONARY: "Stationary",
    SLIDER: "Slider",
};

export { damageLocationsSelected };
